<h1>TERMS &amp; CONDITION OF SALE</h1>

<section>
    <p>THE FOLLOWING TERMS OF SALE APPLY TO FORD MOTOR COMPANY’S INTEGRATED DIAGNOSTIC
    SOFTWARE LICENSES (HEREIN REFERRED TO AS THE PRODUCT OR SOFTWARE LICENSE).</p>
    <ol>
        <li>UNLESS OTHERWISE AGREED, BUYER IS OBLIGATED TO MAKE PAYMENTS TO SELLER OR ITS
    ASSIGNEE IN FULL AT TIME OF SALE. PAYMENTS SHALL BE ABSOLUTE AND UNCONDITIONAL
    AND SHALL CONTINUE UNMODIFIED DESPITE: (A) ANY LOSS, DAMAGE OR OTHER
    INTERRUPTION IN THE USE OF THE SOFTWARE LICENSES; OR (B) ANY DISPUTE, CLAIM,
    COUNTERCLAIM, DEFENSE OR OTHER RIGHT WHICH BUYER MAY HAVE TO ASSERT AGAINST
    SELLER.
        <li>ALL SALES OF LICENSES TO THE PRODUCT ARE FINAL AND NO REFUNDS WILL BE PROVIDED IN
    ANY CIRCUMSTANCES.
    <li>BUYER SHALL BE DEEMED TO HAVE ACCEPTED SOFTWARE LICENSE UPON SELLER’S DELIVERY.
        <li>SELLER IS NOT RESPONSIBLE FOR PERFORMANCE OF SOFTWARE LICENSE IN CONJUNCTION
    WITH ANY HOST PLATFORM, OR ANY IMPACT ON EXISTING HARDWARE OR SOFTWARE.
        <li>SELLER SHALL NOT BE LIABLE FOR ANY FAILURE OR DELAY IN DELIVERING SOFTWARE LICENSE,
    OR FOR ANY FAILURE TO PERFORM ANY PROVISION HEREOF, RESULTING FROM FIRE, FLOOD OR
    OTHER CASUALTY, RIOT, STRIKE OR OTHER LABOR DIFFICULTY, GOVERNMENTAL LEGISLATION
    OR OTHER RESTRICTION, OR ANY OTHER CAUSE BEYOND SELLER’S CONTROL.
        <li>NEITHER THIS AGREEMENT NOR ANY RIGHTS GRANTED HEREUNDER, IN WHOLE OR IN PART
    SHALL BE ASSIGNABLE OR OTHERWISE TRANSFERRABLE BY YOU. NOTHING IN THIS AGREEMENT
    GRANTS TO YOU THE RIGHT TO ASSIGN, SELL, LEASE, LOAN OR OTHERWISE TRANSFER PRODUCT
    IN WHOLE OR IN PART TO A THIRD PARTY.
        <li>YOU AGREE TO THE CURRENT TERMS OF THE PRODUCT’S END USER LICENSE AGREEMENT,
    INCORPORATED HEREIN BY REFERENCE. COPIES OF THE CURRENT END USER LICENSE
    AGREEMENT ARE PUBLISHED TO THE FORD INTEGRATED DIAGNOSTIC SOFTWARE WEBSITE AND
    WITHIN THE FORD INTEGRATED DIAGNOSTIC SOFTWARE PRODUCT.
        <li>IN THE EVENT BUYER BREACHES THIS AGREEMENT, SELLER HAS ALL THE REMEDIES AVAILABLE
    TO A SELLER UNDER APPLICABLE LAW, INCLUDING REVOCATION OF THE SOFTWARE LICENSE(S),
    AND MAY PURSUE ANY OTHER REMEDY AVAILABLE AT LAW OR IN EQUITY. IF BUYER SHALL
    DEFAULT IN THE PAYMENT OF ANY SUM DUE HEREUNDER TO SELLER AND SUCH DEFAULT
    SHALL CONTINUE FOR MORE THAN 10 DAYS AFTER SELLER HAS DEMANDED PAYMENT THEREOF,
    OR BUYER SHALL FAIL OR REFUSE TO PERFORM ANY OTHER PROVISION HEREOF OR
    CONTRAVENE ITS OBLIGATIONS HEREUNDER, OR SHALL BE INSOLVENT OR FILE AN ASSIGNMENT
    OR SUFFER TO BE FILED AGAINST IT UNDER ANY BANKRUPTCY OR INSOLVENCY LAW OR MAKE
    AN ASSIGNMENT (VOLUNTARY OR INVOLUNTARY) FOR THE BENEFIT OF CREDITORS OR SUFFER
    THE APPOINTMENT OF ANY TRUSTEE OR RECEIVER FOR ALL OR ANY PART OF ITS BUSINESS OR
    ASSETS, THEN IN SUCH EVENT, SELLER MAY TERMINATE THIS AGREEMENT AND REVOKE ANY OR
    ALL SOFTWARE LICENSES WITHOUT LEGAL PROCESS. BUYER HEREBY RELIEVES SELLER FROM ALL
    LIABILITY FOR DAMAGES RESULTING FROM REVOCATION SHOULD LEGAL PROCEEDINGS BE
    INSTITUTED BY SELLER OR THIRD PARTIES TO RECOVER ANY AMOUNTS DUE HEREUNDER OR TO
    TAKE POSSESSION OF THE EQUIPMENT AND SOFTWARE, BUYER SHALL PAY ALL COLLECTION
    AND LEGAL EXPENSES (INCLUDING COURT COSTS AND REASONABLE LEGAL FEES). SELLER’S
    RIGHTS SHALL BE CUMULATIVE AND ACTION ON ONE RIGHT SHALL NOT BE DEEMED TO
    CONSTITUTE AN ELECTION OR WAIVER OF THE OTHER RIGHTS TO WHICH SELLER MAY BE
    ENTITLED.
    </ol>
</section>
